import { ChatMessage } from 'src/modules/event/eventAiChatService';

const prefix = 'EVENT_AI_CHAT';

const eventAiChatActions = {
  SET_MESSAGES: `${prefix}_SET_MESSAGES`,
  CLEAR: `${prefix}_CLEAR`,

  doSetMessages: (messages: ChatMessage[]) => (dispatch) => {
    dispatch({
      type: eventAiChatActions.SET_MESSAGES,
      payload: messages,
    });
  },

  doClear: () => (dispatch) => {
    dispatch({
      type: eventAiChatActions.CLEAR,
    });
  },
};

export default eventAiChatActions;
